import { useParams, Link } from 'react-router-dom'
import { blogPosts, products } from '@/lib/data'
import { ProductCard } from '@/components/ProductCard'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'

const BlogPost = () => {
  const { id } = useParams()
  const post = blogPosts.find((p) => p.id === id)
  const relatedProducts = products.slice(0, 2)

  if (!post) {
    return (
      <div className="container py-20 text-center">Post não encontrado.</div>
    )
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <Button variant="ghost" asChild className="mb-6">
        <Link to="/blog">
          <ArrowLeft className="mr-2 h-4 w-4" /> Voltar
        </Link>
      </Button>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-64 md:h-96 object-cover rounded-xl mb-8"
          />
          <h1 className="text-3xl md:text-4xl font-bold mb-4">{post.title}</h1>
          <div className="flex gap-4 text-sm text-muted-foreground mb-8">
            <span>{post.category}</span>
            <span>•</span>
            <span>{new Date(post.date).toLocaleDateString('pt-BR')}</span>
          </div>

          <div className="prose prose-slate max-w-none">
            <p className="lead text-xl text-slate-600 mb-6">{post.excerpt}</p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>
            <h3>A Importância dos Dados</h3>
            <p>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
              quae ab illo inventore veritatis et quasi architecto beatae vitae
              dicta sunt explicabo.
            </p>
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-8">
          <div className="bg-slate-100 p-6 rounded-xl">
            <h3 className="font-bold text-lg mb-4">Produtos Relacionados</h3>
            <div className="space-y-6">
              {relatedProducts.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlogPost
